import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export function useStripeConnectBanner(user) {
  const [needsStripeConnect, setNeedsStripeConnect] = useState(false);
  const [loading, setLoading] = useState(Boolean(user?.uid));

  useEffect(() => {
    if (!user?.uid) {
      setNeedsStripeConnect(false);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    const loadStatus = async () => {
      setLoading(true);
      try {
        const getStatus = httpsCallable(functions, 'getStripeConnectStatus');
        const result = await getStatus();
        if (cancelled) return;
        const status = result.data || {};
        setNeedsStripeConnect(!status.payoutsEnabled);
      } catch (error) {
        console.error('Stripe connect banner status error:', error);
        if (!cancelled) setNeedsStripeConnect(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadStatus();

    return () => {
      cancelled = true;
    };
  }, [user?.uid]);

  return { needsStripeConnect, loading };
}